import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import logoDefender from '../../../../assets/images/logo-defender.svg'

// ========== VERSÃO OFICIAL PDF HTML ==========
export const exportGridToPDF_HTML_OFFICIAL = async (gridComponents, options = {}, onProgress) => {
  const filename = options.filename || 'relatorio_html_v2.pdf'
  const title = options.title || 'Relatório de Dados'
  const includeFACss = options.includeFontAwesomeCss !== false
  const faCssUrl = options.faCssUrl || 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css'
  const maxCellWidthPx = typeof options.maxCellWidthPx === 'number' ? options.maxCellWidthPx : 100
  const reportCssUrl = options.reportCssUrl || (typeof window !== 'undefined' ? `${window.location.origin}/report-export.css` : '/report-export.css')
  const includeAppCss = options.includeAppCss !== false
  const includeGoogleFontsCss = options.includeGoogleFontsCss !== false
  const googleFontsUrl = options.googleFontsUrl || 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap'
  const resolvedLogoUrl = options.logoUrl || (typeof window !== 'undefined' ? new URL(logoDefender, window.location.origin).href : logoDefender)
  
  // Configuração mais agressiva para maximizar linhas por página
  const estimatedRowHeight = 35 // Altura estimada menor para mais linhas
  const headerFooterSpace = 200 // Reduzir espaço reservado para header
  const availableHeight = 1200 - headerFooterSpace // Altura disponível para tabela
  const rowsPerPage = options.rowsPerPage || Math.floor(availableHeight / estimatedRowHeight) // Aproximadamente 28-30 linhas
  
  // Etapa 1: Preparar dados (10%)
  onProgress?.(10, "Preparando dados...");
  
  const appCssLinks = includeAppCss && typeof window !== 'undefined'
    ? (() => {
        try {
          const hrefs = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
            .map(l => l && l.href)
            .filter(Boolean)
          const unique = Array.from(new Set(hrefs))
          const linksStr = unique
            .map(href => { try { return new URL(href, window.location.origin).href } catch { return href } })
            .map(abs => `<link rel="stylesheet" href="${abs}" />`)
            .join('\n')
          const styleTags = Array.from(document.querySelectorAll('style'))
            .map(s => s && s.textContent)
            .filter(css => css && css.trim().length > 0)
          const inlineStr = styleTags.length ? `<style>\n${styleTags.join('\n\n')}\n</style>` : ''
          return `${linksStr}\n${inlineStr}`
        } catch { return '' }
      })()
    : ''

  const tableComponent = gridComponents?.BODY[0]?.Childrens?.find(
    (c) => c.Chave_Transacao_Componente === 'TABELA_RESULTADOS_GRID_001'
  );
  if (!tableComponent) throw new Error('Tabela não encontrada');

  // Usar dados filtrados se disponíveis
  let dataResult = [];
  if (options.filteredData && Array.isArray(options.filteredData)) {
    dataResult = options.filteredData;
  } else {
    try {
      dataResult = JSON.parse(
        tableComponent.Childrens.find(
          (c) => c.Chave_Transacao_Componente === 'PROCEDURE_RESULTSET'
        )?.Valor_Componente || '[]'
      ) || [];
    } catch (_) { dataResult = []; }
  }

  const columnsList = JSON.parse(
    tableComponent.Childrens.find(
      (c) => c.Chave_Transacao_Componente === 'TABELA_RESULTADOS_GRID_LISTA_COLUNAS'
    )?.Valor_Componente || '[]'
  );

  const exportColumns = columnsList.filter((col) =>
    (col.Export !== 'False' && col.Export !== false)
  );

  const escapeHtml = (str) => String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const extractFirstIconOrImageHtml = (html) => {
    try {
      if (typeof document === 'undefined') return '';
      const container = document.createElement('div');
      container.innerHTML = String(html);
      let found = container.querySelector('img, i');
      if (!found && /&lt;\/?(img|i)\b/i.test(String(html))) {
        const decodeWrap = document.createElement('div');
        decodeWrap.innerHTML = String(html);
        const decoded = decodeWrap.textContent || decodeWrap.innerText || '';
        const reparse = document.createElement('div');
        reparse.innerHTML = decoded;
        found = reparse.querySelector('img, i');
      }
      if (!found) return '';
      const tag = found.tagName.toLowerCase();
      if (tag === 'img') {
        const img = document.createElement('img');
        const src = found.getAttribute('src');
        if (!src) return '';
        img.setAttribute('src', src);
        const cls = found.getAttribute('class');
        if (cls) img.setAttribute('class', cls);
        const alt = found.getAttribute('alt') || '';
        if (alt) img.setAttribute('alt', alt);
        return img.outerHTML;
      }
      if (tag === 'i') {
        const iEl = document.createElement('i');
        const cls = found.getAttribute('class');
        if (cls) iEl.setAttribute('class', cls);
        const ariaHidden = found.getAttribute('aria-hidden');
        if (ariaHidden) iEl.setAttribute('aria-hidden', ariaHidden);
        return iEl.outerHTML;
      }
      return '';
    } catch (_) { return ''; }
  };

  const renderCell = (value, col) => {
    if (value == null) return '';
    if (col.hasImage === 'True' || col.hasImage === true) {
      try {
        const parsed = typeof value === 'string' ? JSON.parse(value) : value
        const arr = Array.isArray(parsed) ? parsed : [parsed]
        const colLabel = `${col?.header || ''} ${col?.field || ''}`.toLowerCase()
        const isAvatarColumn = /(foto|photo|avatar|usu[aá]rio|user|perfil|face|imagem.*pessoa)/.test(colLabel)
        const isValidImageSrc = (src) => {
          if (!src && src !== 0) return false
          const s = String(src).trim()
          if (!s || s === '[]' || s === '{}' || s.toLowerCase() === 'null' || s.toLowerCase() === 'undefined') return false
          if (s.startsWith('data:image')) return true
          if (/^https?:\/\//i.test(s)) return true
          if (/^\//.test(s)) return true
          return false
        }
        const parts = arr.map((it) => {
          if (it && typeof it === 'object' && it.tipo === 'image') {
            const src = it?.valor
            if (isValidImageSrc(src)) {
              const cls = isAvatarColumn ? 'img-avatar' : 'img-inline'
              return `<img src="${escapeHtml(src)}" class="${cls}"/>`
            }
            return ''
          }
          if (it && typeof it === 'object' && it.tipo === 'icone' && it?.valor) {
            return `<i class="${escapeHtml(it.valor)}"></i>`
          }
          if (it && typeof it === 'object' && it.tipo === 'texto' && it?.valor != null && it.valor !== '') {
            return `<span class="text-inline">${escapeHtml(String(it.valor))}</span>`
          }
          if (typeof it === 'string' && (/[<](img|i)\b/i.test(it) || /d-flex|user-photo-label|fa-user-circle/i.test(it))) {
            const normalized = extractFirstIconOrImageHtml(it);
            if (normalized) return normalized;
          }
          if (typeof it === 'string' && isValidImageSrc(it)) {
            const cls = isAvatarColumn ? 'img-avatar' : 'img-inline'
            return `<img src="${escapeHtml(it)}" class="${cls}"/>`
          }
          return ''
        })
        const joined = parts.join('')
        if (joined && joined.trim().length > 0) {
          return `<span class="icon-cell">${joined}</span>`
        }
        return `<span class="icon-cell"><i class="far fa-user-circle font-size-32 user-photo-label" aria-hidden="true"></i></span>`
      } catch (_) {
        if (typeof value === 'string' && (/[<](img|i)\b/i.test(value) || /d-flex|user-photo-label|fa-user-circle/i.test(value))) {
          const normalized = extractFirstIconOrImageHtml(value);
          if (normalized) return `<span class="icon-cell">${normalized}</span>`;
        }
        return `<span class="icon-cell"><i class="far fa-user-circle font-size-32 user-photo-label" aria-hidden="true"></i></span>`;
      }
    }
    const str = typeof value === 'string' ? value : String(value)
    const cleaned = str.replace(/[^\x20-\x7E\n\r\t]/g, '')
    const trimmed = cleaned.trim()
    if (/[<](img|i)\b/i.test(trimmed) || /d-flex|user-photo-label|fa-user-circle/i.test(trimmed)) {
      const normalized = extractFirstIconOrImageHtml(trimmed)
      if (normalized) return `<span class="icon-cell">${normalized}</span>`
    }
    return escapeHtml(cleaned)
  };

  // Dividir dados em páginas
  const paginateData = (data, rowsPerPage) => {
    const pages = []
    for (let i = 0; i < data.length; i += rowsPerPage) {
      pages.push(data.slice(i, i + rowsPerPage))
    }
    return pages.length > 0 ? pages : [[]]
  }
  
  // Etapa 2: Processar dados (30%)
  onProgress?.(30, "Processando dados...");
  
  const dataPages = paginateData(dataResult, rowsPerPage)
  const totalPages = dataPages.length

  const headers = exportColumns.map((c) => {
    const widthStyle = c.width ? ` style="width: ${c.width};"` : '';
    return `<th${widthStyle}>${escapeHtml(c.header)}</th>`;
  }).join('')

  const headerHtml = `
    <div class="defender-header">
      <div class="defender-logo">
        <img src="${escapeHtml(resolvedLogoUrl)}" alt="Defender" class="defender-logo-img"/>
      </div>
      <div class="report-title">${escapeHtml(title)}</div>
    </div>`

  const filtersBarHtml = (() => {
    const pills = []
    const filterObj = options.appliedFilters?.[0] || {}
    Object.keys(filterObj).forEach((key) => {
      const filter = filterObj[key]
      if (Array.isArray(filter)) {
        if (filter[0]?.values && filter[0]?.field) {
          filter[0].values.forEach((v) => pills.push(String(v.label || v.value)))
        }
      } else if (filter && typeof filter === 'object') {
        const value = filter.label || filter.value
        if (value) pills.push(String(value))
      }
    })
    const transactionCode = options.transactionCode || ''
    const leftHtml = pills.length
      ? `<span class="filters-title">Filtros aplicados:</span><span class="filter-list">${pills.map(p => `<span class="filter-pill">${escapeHtml(p)}</span>`).join('')}</span>`
      : ''
    return `
      <div class="filters-bar">
        <div class="filters-left">${leftHtml}</div>
        <div class="code-display"><b>Código:</b> ${escapeHtml(transactionCode)}</div>
      </div>`
  })()

  // Labels dinâmicos do contexto
  const getAttributeValueByKey = (gc, key) => {
    try {
      const fromHead = gc?.HEAD?.[0]?.Childrens?.find?.((c) => c.Chave_Transacao_Componente === key)?.Valor_Componente;
      if (fromHead != null) return fromHead;
      const fromBody = gc?.BODY?.[0]?.Childrens?.find?.((c) => c.Chave_Transacao_Componente === key)?.Valor_Componente;
      if (fromBody != null) return fromBody;
      return null;
    } catch (_) { return null; }
  };
  let contextColumns = [];
  try { contextColumns = JSON.parse(getAttributeValueByKey(gridComponents, 'CONTEXTO_LISTA_COLUNAS') || '[]'); } catch (_) { contextColumns = []; }
  const contextUserNameHeader = Array.isArray(contextColumns) ? (contextColumns.find(c => c.field === 'Nome_Completo')?.header || '') : '';
  const contextDepartmentHeader = Array.isArray(contextColumns) ? (contextColumns.find(c => c.field === 'Departamento')?.header || '') : '';
  const contextRoleHeader = Array.isArray(contextColumns) ? (contextColumns.find(c => c.field === 'Cargo')?.header || '') : '';
  const userNameLabel = options?.labels?.userNameLabel || contextUserNameHeader || 'Nome do Usuário';
  const departmentLabel = options?.labels?.departmentLabel || contextDepartmentHeader || 'Departamento';
  const roleLabel = options?.labels?.roleLabel || contextRoleHeader || 'Cargo';

  const collectContextCompanyLogos = () => {
    try {
      if (typeof document === 'undefined') return [];
      const nodeList = document.querySelectorAll('.card-context-dynamic .img-card');
      const srcs = Array.from(nodeList).map(img => img && img.getAttribute && img.getAttribute('src')).filter(s => typeof s === 'string' && s.trim().length > 0);
      return Array.from(new Set(srcs));
    } catch (_) { return []; }
  };

  const userInfoHtml = (() => {
    // Mostra o box apenas se existir CONTEXTO_001 no HEADER da transação
    const hasUserContext = (() => {
      try {
        const headerChildren = gridComponents?.HEADER?.[0]?.Childrens
        if (!Array.isArray(headerChildren)) return false
        return headerChildren.some((c) => c?.Chave_Transacao_Componente === 'CONTEXTO_001')
      } catch { return false }
    })()
    if (!hasUserContext) return ''

    const getSafe = (obj, keys, fallback = '') => { try { return keys.reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : null), obj) ?? fallback } catch { return fallback } }
    const parseFoto = (foto) => {
      if (!foto) return null
      if (typeof foto === 'string') {
        if (foto.startsWith('data:image') || foto.startsWith('http')) return foto
        try { const parsed = JSON.parse(foto); if (Array.isArray(parsed) && parsed[0]?.valor) return parsed[0].valor } catch {}
      }
      return null
    }
    let userInfo = options.userInfo || null
    if (!userInfo && typeof window !== 'undefined') {
      try {
        const raw = window.localStorage.getItem('authUser')
        const obj = raw ? JSON.parse(raw) : {}
        const profile = getSafe(obj, ['resultset_2', 0]) || getSafe(obj, ['resultset_1', 0]) || obj
        userInfo = {
          nome: profile.Nome_Completo || profile.Nome_Usuario || profile.Apelido || '',
          cargo: profile.Cargo || '',
          departamento: profile.Departamento || '',
          foto: parseFoto(profile.Foto_Usuario) || profile.Foto_Usuario || null,
        }
      } catch {}
    }
    const companiesLogos = Array.isArray(options.userCompaniesLogos) ? options.userCompaniesLogos : collectContextCompanyLogos()
    const companiesHtml = companiesLogos.map((logo) => `<img src="${escapeHtml(String(logo))}" class="company-logo" alt="Empresa"/>`).join('')
    return `
      <div class="user-info-grid">
        <div class="user-col user-name">
          <div class="user-avatar">${userInfo?.foto ? `<img src="${escapeHtml(userInfo.foto)}" class="user-avatar-img" alt="${escapeHtml(userInfo?.nome || 'Usuário')}"/>` : `<i class="far fa-user-circle"></i>`}</div>
          <div class="user-name-info">
            <div class="user-label">${escapeHtml(userNameLabel)}</div>
            <div class="user-value">${escapeHtml(userInfo?.nome || '')}</div>
          </div>
        </div>
        <div class="user-col">
          <div class="user-label">${escapeHtml(departmentLabel)}</div>
          <div class="user-value">${escapeHtml(userInfo?.departamento || '')}</div>
        </div>
        <div class="user-col">
          <div class="user-label">${escapeHtml(roleLabel)}</div>
          <div class="user-value">${escapeHtml(userInfo?.cargo || '')}</div>
        </div>
        <div class="user-col">
          <div class="user-label">Empresas</div>
          <div class="user-value companies">${companiesHtml}</div>
        </div>
      </div>`
  })()

  // Totalizadores dinâmicos (Nome_Totalizador / Valor_Totalizador)
  const findTotalsInComponents = (root) => {
    const totals = [];
    try {
      const stack = Array.isArray(root) ? [...root] : [root];
      while (stack.length) {
        const node = stack.pop();
        if (!node || typeof node !== 'object') continue;
        if (Array.isArray(node)) { node.forEach(n => stack.push(n)); continue; }
        if (node.Chave_Transacao_Componente === 'PROCEDURE_RESULTSET' && typeof node.Valor_Componente === 'string') {
          try {
            const parsed = JSON.parse(node.Valor_Componente || '[]');
            if (Array.isArray(parsed) && parsed.length > 0) {
              const first = parsed[0];
              const hasTotals = first && typeof first === 'object' && 'Nome_Totalizador' in first && 'Valor_Totalizador' in first;
              if (hasTotals) {
                parsed.forEach(it => {
                  if (it && typeof it === 'object' && it.Nome_Totalizador != null && it.Valor_Totalizador != null) {
                    totals.push({ Nome_Totalizador: String(it.Nome_Totalizador), Valor_Totalizador: String(it.Valor_Totalizador) });
                  }
                });
              }
            }
          } catch (_) {}
        }
        if (node.Childrens) stack.push(node.Childrens);
        if (node.HEAD) stack.push(node.HEAD);
        if (node.BODY) stack.push(node.BODY);
      }
    } catch (_) {}
    return totals;
  };
  const totalsItems = findTotalsInComponents(gridComponents);
  const totalsBodyHtml = totalsItems.length > 0
    ? totalsItems.map(t => `<div class="totals-body">${escapeHtml(t.Nome_Totalizador)} <b>${escapeHtml(t.Valor_Totalizador)}</b></div>`).join('')
    : `<div class="totals-body">registros <b>${dataResult.length}</b></div>`;
  const totalsBarHtml = `
    <div class="totals-bar">
      <div class="totals-chip">Totalizadores</div>
      ${totalsBodyHtml}
    </div>`

  // Preparar dados do footer
  const d = new Date(); const pad = (n) => String(n).padStart(2, '0')
  const stamp = `${pad(d.getDate())}/${pad(d.getMonth()+1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`
  
  // Obter nome do usuário para V2
  let userNameV2 = ''
  if (options.userInfo?.nome) {
    userNameV2 = options.userInfo.nome
  } else if (typeof window !== 'undefined') {
    try {
      const raw = window.localStorage.getItem('authUser')
      const obj = raw ? JSON.parse(raw) : {}
      const profile = obj?.resultset_2?.[0] || obj?.resultset_1?.[0] || obj
      userNameV2 = profile?.Nome_Completo || profile?.Nome_Usuario || profile?.Apelido || ''
    } catch {}
  }
  const nome = userNameV2

  // Etapa 3: Gerar PDF (50%)
  onProgress?.(50, "Gerando PDF...");
  
  // Gerar PDFs para cada página separadamente
  const pdf = new jsPDF('p', 'mm', 'a4')
  let isFirstPage = true

  for (let pageIndex = 0; pageIndex < dataPages.length; pageIndex++) {
    // Progresso mais suave por página (50% a 85%)
    const pageProgress = 50 + (pageIndex / dataPages.length) * 35;
    onProgress?.(Math.round(pageProgress), `Processando página ${pageIndex + 1} de ${dataPages.length}`);
    
    if (!isFirstPage) pdf.addPage()
    
    const pageData = dataPages[pageIndex]
    const pageNumber = pageIndex + 1
    const rows = pageData.map((row) => {
      const tds = exportColumns.map((col) => {
        const content = renderCell(row[col.field], col)
        const widthStyle = col.width ? ` style="width: ${col.width};"` : '';
        return `<td class="cell"${widthStyle}>${content}</td>`
      }).join('')
      return `<tr>${tds}</tr>`
    }).join('\n')

    // Componentes específicos da página
    const currentUserInfoHtml = pageNumber === 1 ? userInfoHtml : ''
    const currentFiltersBarHtml = pageNumber === 1 ? filtersBarHtml : ''
    const currentTotalsBarHtml = pageNumber === totalPages ? totalsBarHtml : ''

    const pageHtml = `<!DOCTYPE html>
    <html lang="pt-BR">
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <title>${escapeHtml(title)}</title>
      <style>
        :root{--cell-max-width: ${maxCellWidthPx}px;}
        body { padding-bottom: 10px; margin: 0; font-family: "Poppins", sans-serif; }
        .main-content { padding: 0px 20px 5px 20px !important; }
        table { table-layout: fixed !important; width: 100% !important; }
        table th, table td { padding: 10px 8px !important; font-size: 12px !important; overflow: hidden !important; word-wrap: break-word !important; white-space: normal !important; }
        td.cell { padding-top: 10px !important; padding-bottom: 10px !important; }
        .defender-header { padding: 8px 20px !important; }
        .filters-bar { padding: 5px 20px !important; }
        .user-info-grid { padding: 8px 20px !important; margin: 0px 20px !important; }
        .totals-bar { margin: 8px 20px !important; }
      </style>
      <link rel="stylesheet" href="${reportCssUrl}" />
      ${includeGoogleFontsCss ? `<link rel="stylesheet" href="${googleFontsUrl}" />` : ''}
      ${includeFACss ? `<link rel="stylesheet" href="${faCssUrl}" crossorigin="anonymous" referrerpolicy="no-referrer" />` : ''}
      ${appCssLinks}
    </head>
    <body>
      ${headerHtml}
      ${currentFiltersBarHtml}
      ${currentUserInfoHtml}
      <div class="main-content">
        <table>
          <thead><tr>${headers}</tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </div>
      ${currentTotalsBarHtml}
    </body>
    </html>`

    // Calcular altura dinâmica baseada no conteúdo da página
    const baseHeight = 250 // Reduzir altura base para dar mais espaço à tabela
    const tableHeight = pageData.length * estimatedRowHeight + 80 // Linhas + header da tabela
    const dynamicHeight = Math.max(600, baseHeight + tableHeight)
    
    // Criar iframe para esta página
    const iframe = document.createElement('iframe')
    iframe.style.position = 'fixed'
    iframe.style.left = '0'
    iframe.style.top = '0'
    iframe.style.width = '1024px'
    iframe.style.height = `${dynamicHeight}px`
    iframe.style.opacity = '0'
    iframe.style.pointerEvents = 'none'
    document.body.appendChild(iframe)
    
    const idoc = iframe.contentDocument || iframe.contentWindow.document
    idoc.open(); idoc.write(pageHtml); idoc.close()
    await new Promise(r => setTimeout(r, 100))
    try { if (idoc.fonts && idoc.fonts.ready) await idoc.fonts.ready } catch(_) {}

    // Etapa 4: Renderizar página (progresso mais suave)
    const renderProgress = 50 + ((pageIndex + 0.5) / dataPages.length) * 35;
    onProgress?.(Math.round(renderProgress), `Processando página ${pageIndex + 1} de ${dataPages.length}`);

    const pageZoom = typeof options.zoom === 'number' && options.zoom > 0 && options.zoom <= 1 ? options.zoom : 0.9
    const canvas = await html2canvas(idoc.body, { 
      scale: 2,
      useCORS: true, 
      allowTaint: true, 
      windowWidth: Math.round(1024/pageZoom), 
      backgroundColor: '#ffffff' 
    })
    
    const imgData = canvas.toDataURL('image/jpeg', 0.92)
    const pageWidth = pdf.internal.pageSize.getWidth()
    const pageHeight = pdf.internal.pageSize.getHeight()
    
    const margin = 10
    const pdfFooterHeight = 15
    const footerMargin = 5
    const imgWidth = pageWidth - margin * 2
    const imgHeight = canvas.height * imgWidth / canvas.width
    
    // Adicionar imagem da página
    pdf.addImage(imgData, 'JPEG', margin, margin, imgWidth, imgHeight)
    
    // Adicionar rodapé mais próximo do conteúdo
    const footerText = `Emitido por: ${nome} às ${stamp}`
    const pageText = `Página ${pageNumber} de ${totalPages}`
    
    // Posicionar rodapé logo após o conteúdo, mas respeitando margem mínima
    const contentBottom = margin + imgHeight
    const minFooterY = pageHeight - pdfFooterHeight - footerMargin
    const footerY = Math.min(contentBottom + 5, minFooterY) // 5mm de espaço após conteúdo
    
    pdf.setFontSize(9)
    pdf.setTextColor(255, 255, 255)
    pdf.setFillColor(36, 78, 162)
    pdf.rect(0, footerY, pageWidth, pdfFooterHeight, 'F')
    
    const textY = footerY + (pdfFooterHeight / 2) + 2
    pdf.text(footerText, 10, textY)
    pdf.text(pageText, pageWidth - 10, textY, { align: 'right' })

    // Limpar iframe
    try { document.body.removeChild(iframe) } catch (_) {}
    
    isFirstPage = false
  }

  // Etapa 5: Finalizar PDF (95% a 100%)
  onProgress?.(95, "Finalizando PDF...");
  await new Promise(resolve => setTimeout(resolve, 200)); // Pequena pausa para visualizar
  onProgress?.(100, "PDF pronto!");

  pdf.save(filename)
}

// Exportar a versão oficial como principal
export { exportGridToPDF_HTML_OFFICIAL as exportGridToPDF_HTML }
export default exportGridToPDF_HTML_OFFICIAL


